import { apCommandCenterContracts } from "./ap-command-center.contract";
import { apThroughputContracts } from "./ap-throughput.contract";
import { apInvoicesContracts } from "./ap-invoices.contract";
import { suppliersContracts } from "./suppliers.contract";
import { purchaseOrdersContracts } from "./purchase-orders.contract";
import { scheduledPaymentsContracts } from "./scheduled-payments.contract";
import { documentSearchContracts } from "./document-search.contract";
import { supplierPaymentDetailsContracts } from "./supplier-payment-details.contract";
import { supplierContactsContracts } from "./supplier-contacts.contract";
import { apExceptionRuleSetsContracts } from "./exception-rule-sets.contract";
import { supplierProductMatchesContracts } from "./supplier-product-matches.contract";
import { supplierDocumentLinesContracts } from "./supplier-document-lines.contract";

export const accountsPayableContracts = {
  commandCenter: apCommandCenterContracts,
  throughput: apThroughputContracts,
  exceptionRuleSets: apExceptionRuleSetsContracts,
  invoices: apInvoicesContracts,
  suppliers: suppliersContracts,
  purchaseOrders: purchaseOrdersContracts,
  scheduledPayments: scheduledPaymentsContracts,
  documentSearch: documentSearchContracts,
  supplierPaymentDetails: supplierPaymentDetailsContracts,
  supplierContacts: supplierContactsContracts,
  supplierProductMatches: supplierProductMatchesContracts,
  supplierDocumentLines: supplierDocumentLinesContracts,
} as const;

export * from "./ap-command-center.contract";
export * from "./ap-throughput.contract";
export * from "./ap-invoices.contract";
export * from "./purchase-orders.contract";
export * from "./suppliers.contract";
export * from "./scheduled-payments.contract";
export * from "./document-search.contract";
export * from "./supplier-payment-details.contract";
export * from "./supplier-contacts.contract";
export * from "./exception-rule-sets.contract";
export * from "./supplier-product-matches.contract";
export * from "./supplier-document-lines.contract";
